import { Component,OnInit,OnDestroy,AfterViewInit,Input } from '@angular/core';

@Component({
    selector: "icon-logo-crestinvolvement"
    ,templateUrl: "./icon.logo.crestinvolvement.component.html"
    ,styleUrls: ["./icon.logo.crestinvolvement.component.scss"]
})
export class IconLogoCrestinvolvementComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    @Input() bgColor:string = "fill-success";
    @Input() borderColor:string = "";
    @Input() imgWidth:string = "";
    @Input() imgHeight:string = "";

    constructor(){

    }

    ngOnInit() {
        let dW = 984;
        let dH = 248;
        if(!this.imgHeight) {
            let cW = parseInt(this.imgWidth);
            let tH = cW * dH / dW;
            // 실제 로고 클릭 시 이동할 기본 링크 (필요시)
            window.open('https://allgps.co.kr/', '_blank');
            this.imgHeight = "" + tH;
        }else{
            let cH = parseInt(this.imgHeight);
            let tW = cH * dW / dH;
            this.imgWidth = "" + tW;
        }
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {
        
    }
}